/**
 * AP Product Card Component
 * For ap-card-product snippet variant image switching
 */
class ApProductCard extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Use setTimeout to ensure DOM is fully rendered
    setTimeout(() => {
      this.setupSwatches();
    }, 0);
  }

  setupSwatches() {
    const colorSwatches = this.querySelector('.color-swatches');
    if (!colorSwatches) return;

    // Initialize: ensure first swatch and first image container are active
    const firstSwatch = colorSwatches.querySelector('.color-swatch');
    const firstContainer = this.querySelector('.ap-variant-image-container[data-index="0"]');
    
    if (firstSwatch && !firstSwatch.classList.contains('active')) {
      firstSwatch.classList.add('active');
    }
    
    if (firstContainer) {
      firstContainer.classList.remove('hidden');
      this.classList.add('has-swatch-active');
    }

    // Use event delegation, bind on container
    colorSwatches.addEventListener('click', (e) => {
      this.handleSwatchClick(e);
    });
  }

  handleSwatchClick(event) {
    // Prevent default behavior and event bubbling
    event.preventDefault();
    event.stopPropagation();

    // Find the clicked swatch
    const swatch = event.target.closest('.color-swatch');
    if (!swatch) return;

    // Skip disabled swatches
    if (swatch.classList.contains('disabled')) return;

    // Get index
    const index = swatch.getAttribute('data-index');
    if (index === null) return;

    // If clicking an already active swatch, do nothing
    if (swatch.classList.contains('active')) return;

    // Find all image containers
    const allContainers = this.querySelectorAll('.ap-variant-image-container');
    if (!allContainers.length) return;

    // Find target image container
    const targetContainer = this.querySelector(
      `.ap-variant-image-container[data-index="${index}"]`
    );
    if (!targetContainer) return;

    // Find current active container
    const currentContainer = this.querySelector('.ap-variant-image-container:not(.hidden)');

    // Remove active state from all swatches
    const allSwatches = this.querySelectorAll('.color-swatch');
    allSwatches.forEach((s) => s.classList.remove('active'));

    // Activate current swatch
    swatch.classList.add('active');

    // Add has-swatch-active class to main container
    this.classList.add('has-swatch-active');

    // Smooth transition: hide all, then show target with fade
    allContainers.forEach((container) => {
      if (container !== targetContainer) {
        container.classList.add('hidden');
      }
    });

    // Show target container with smooth fade in
    targetContainer.classList.remove('hidden');
    
    // Force reflow to ensure transition works
    void targetContainer.offsetHeight;

    // Sync variant ID to add-to-cart form
    const variantId = swatch.getAttribute('data-variant-id');
    console.log(variantId);
    
    if (variantId) {
      const variantInput = this.querySelector('.product-variant-id');
      if (variantInput) variantInput.value = variantId;
    }
  }
}

// Register custom element
if (!customElements.get('ap-product-card')) {
  customElements.define('ap-product-card', ApProductCard);
}
